import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Select, Icon, Button } from 'antd'
import Formsy from 'formsy-react'
import Dropzone from 'react-dropzone'

import Autocomplete from 'components/Autocomplete'
import CustomInput from 'components/CustomInput'
import { fetchLogisticOperators, pendingConfirmSendToLogisticOperator } from 'screens/LoadsDetails/actions'
import { fetchOccurrenceTypesByShipperId } from 'actions/system'
import avatarURLParse from 'utils/urlParser'
import { removeAccentuation } from 'utils/stringFormatter'
import { incidentCategoriesMap } from 'utils/constants'

import css from './index.scss'

const Option = Select.Option

const LogisticOperator = ({
  load,
  onCloseClick,
  logisticOperators,
  fetchLogisticOperators,
  incidentTypes,
  fetchOccurrenceTypes,
  confirmSendToLogisticOperator,
}) => {
  const [filterLogisticOperatorName, setFilterLogisticOperatorName] = useState('')
  const [filterLogisticOperator, setFilterLogisticOperator] = useState(null)
  const [incidentName, setIncidentName] = useState('')
  const [selectedIncident, setSelectedIncident] = useState(null)
  const [observation, setObservation] = useState('')
  const [images, setImages] = useState([])
  const [imageHoveredIndex, setImageHoveredIndex] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    load && fetchLogisticOperators(load.operationGroup.id)
    if (load && load.shipper && load.shipper.id) {
      fetchOccurrenceTypes(load.shipper.id)
    }
  }, [fetchLogisticOperators, fetchOccurrenceTypes])


  const handleDeleteFile = (e, index) => {
    e.stopPropagation()
    e.preventDefault()
    const newImages = [
      ...images.slice(0, index),
      ...images.slice(index + 1),
    ]
    setImages(newImages)
  }

  const handleConfirmLogisticOperator = (e) => {
    e.stopPropagation()
    e.preventDefault()

    if (!filterLogisticOperatorName || !incidentName || !observation) {
      setError(true)
    } else {
      setError(false)
      confirmSendToLogisticOperator(
        load.hashId,
        load.deliveryId,
        {
          attachments: images,
          logisticOperatorId: filterLogisticOperator.id,
          occurrenceType: selectedIncident.id,
          occurrenceObservation: observation,
        },
        onCloseClick,
      )
    }
  }

  return (
    <React.Fragment>
      <div className={css.logisticOperatorField}>
        <Autocomplete
          allowClear
          defaultValue={filterLogisticOperatorName}
          value={filterLogisticOperatorName}
          label="Operador logistico"
          placeholder="Buscar pelo nome do operador logistico"
          data={logisticOperators}
          width="100%"
          style={{ height: 30 }}
          inputClassName={css.searchInput}
          className={css.searchContainer}
          filterOption={
            (inputValue, option) => {
              const words = inputValue.split(' ')
              let include = true
              words.map((term) => {
                if (!option.props.value
                  .toUpperCase().includes(term.toUpperCase())) {
                  include = false
                }
                return null
              })
              return include
            }}
          labelName="logisticOperators"
          onSelect={(value, option) => {
            setFilterLogisticOperator(option.props.data)
            setFilterLogisticOperatorName(value)
          }}
          onChange={(value) => {
            if (!value) {
              setFilterLogisticOperator(null)
            }
            setFilterLogisticOperatorName(value)
          }}
          renderCustomOptions={() => logisticOperators.map(logisticOperator => (
            <Option
              key={logisticOperator.hashId}
              value={logisticOperator.fantasyName}
              data={logisticOperator}
            >
              <div className={css.row} style={{ alignItems: 'center' }}>
                <img
                  src={avatarURLParse(logisticOperator.imageLogo)}
                  alt={logisticOperator.fantasyName}
                  className={css.shipperFilterAvatar}
                  onError={(e) => { e.target.src = '/assets/icons/no-camera.svg' }}
                />
                <span className={css.shipperFilterName}>{logisticOperator.fantasyName}</span>
              </div>
            </Option>
          ))}
        />
        {error && !filterLogisticOperatorName && <span className={css.error}>Favor informar o operador logistico</span>}
      </div>
      <div className={css.logisticOperatorField}>
        <Autocomplete
          allowClear
          label="Tipo de Ocorrência"
          placeholder="Buscar pelo tipo de ocorrência"
          defaultValue={incidentName}
          value={incidentName}
          data={incidentTypes}
          filterOption={
            (inputValue, option) => {
              const value = removeAccentuation(inputValue.toLowerCase())
              const children = option.props.children
              const optionValue = typeof children === 'string' ? children : ''
              return removeAccentuation(optionValue.toLowerCase()).indexOf(value) !== -1
            }
          }
          groupData
          groupDataTitle="category"
          groupDataChildren="types"
          labelName="name"
          keyName="id"
          onSelect={(value, option) => setSelectedIncident(option.props.data)}
          containerStyle={{
            width: '100%',
          }}
          onChange={(value) => {
            if (!value) {
              setSelectedIncident(null)
            }
            setIncidentName(value)
          }}
        />
        {error && !incidentName && <span className={css.error}>Favor informar o tipo de ocorrência</span>}
      </div>
      <div className={css.logisticOperatorField}>
        <span className={css.section}>
          Comprovantes e outros anexos ({images && images.length})
        </span>
        <Dropzone
          className={css.dropzone}
          onDrop={(image) => setImages(...images, image)}
          style={images && images.length ? null : { justifyContent: 'center', alignItems: 'center' }}
          multiple
        >
          {images && !!images.length
            ? images.map((image, index) => (
              <div
                className={css.attachmentContainer}
                onMouseEnter={() => setImageHoveredIndex(index)}
                onMouseLeave={() => setImageHoveredIndex(null)}
                key={index}
              >
                {(imageHoveredIndex !== null && imageHoveredIndex === index) && (
                  <div
                    className={css.deleteContainer}
                    tabIndex={0}
                    role="button"
                    onClick={e => handleDeleteFile(e, index)}
                  >
                    <Icon
                      type="delete"
                      theme="filled"
                      style={{ color: '#f5222d', fontSize: 20 }}
                    />
                  </div>
                )}
                <img
                  className={css.attachment}
                  src={image.preview}
                  alt="preview"
                />
                <span className={css.attachmentLabel}>
                  {image.name}
                </span>
              </div>
            )) : (
              <div className={css.column}>
                <img alt="upload" src="/assets/icons/upload-button.svg" className={css.iconUpload} />
                <span className={css.data} style={{ textAlign: 'center' }}>Arraste uma ou mais imagens para cá...</span>
                <span className={css.data} style={{ textAlign: 'center', fontSize: 13 }}>(.png, .jpg, .jpeg)</span>
              </div>
            )
          }
        </Dropzone>
      </div>
      <div className={css.logisticOperatorField}>
        <span className={css.section}>Observação sobre esta entrega</span>
        <Formsy>
          <div
            style={{ display: 'flex', flex: 0.9, flexDirection: 'row', justifyContent: 'center' }}
          >
            <CustomInput
              name="observation"
              placeholder="Escreva aqui alguma observação sobre a entrega caso necessário..."
              style={{ display: 'flex', flex: 1 }}
              inputStyle={{ height: 64, width: '100%', resize: 'none' }}
              formStyle={{ width: '100%' }}
              textArea
              gray
              required
              onChange={(e) => setObservation(e.target.value)}
              value={observation}
            />
          </div>
        </Formsy>
        {error && !observation && <span className={css.error}>Favor informar a observação</span>}
      </div>
      <div className={css.row} style={{ justifyContent: 'flex-end' }}>
        <Button
          type="primary"
          onClick={(e) => handleConfirmLogisticOperator(e)}
        >
          Confirmar entrega <Icon type="check" />
        </Button>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  logisticOperators: state.loadsDetails.logisticOperators,
  incidentTypes: Object.entries(state.system.incidentData)
    .map(([key, value]) => ({ category: incidentCategoriesMap[key.toUpperCase()], types: value })),
})

const mapActionsToProps = dispatch => ({
  fetchLogisticOperators(operationGroup) {
    dispatch(fetchLogisticOperators(operationGroup))
  },
  fetchOccurrenceTypes(id) {
    dispatch(fetchOccurrenceTypesByShipperId(id))
  },
  confirmSendToLogisticOperator(hashId, deliveryId, sendToLogisticOperatorRequest, cb) {
    dispatch(pendingConfirmSendToLogisticOperator(hashId, deliveryId, sendToLogisticOperatorRequest, cb))
  },
})

export default connect(mapStateToProps, mapActionsToProps)(LogisticOperator)
